import type { PropsWithChildren, ReactNode } from 'react';
import { Heading } from '@invisionag/components';

export function StepSection({
  icon,
  title,
  children,
}: PropsWithChildren<{ icon: ReactNode; title: ReactNode }>) {
  return (
    <>
      {icon}
      <div className="flex flex-col gap-4">
        <Heading level={3}>{title}</Heading>
        {children}
      </div>
    </>
  );
}
